import { createFileRoute } from '@tanstack/react-router';
import { HOME_FAQS } from 'features/Landing/content';
import { ContactPanel } from 'features/Landing/sections/ContactPanel';
import { Faq } from 'features/Landing/sections/Faq';
import { type FC } from 'react';
import { breadcrumbJsonLd, buildHead, faqJsonLd } from 'seo/head';

const ContactPage: FC = () => (
  <>
    <section className="bg-ink-900 pt-32 pb-16 sm:pt-40 sm:pb-20">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8">
        <p className="font-mono text-xs tracking-[0.25em] text-brand-400 uppercase">
          Contact - free fixed quotes
        </p>
        <h1 className="font-display mt-4 max-w-3xl text-4xl leading-tight font-bold text-white sm:text-5xl">
          Get a quote, ask a question, book a job
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-300 sm:text-lg">
          Call, email, or use the form. Plans and photos speed everything up. Quotes are free,
          fixed, and usually back within two working days.
        </p>
      </div>
    </section>
    <ContactPanel sheet="DB-01 - Get a quote" />
    <Faq faqs={HOME_FAQS} sheet="DB-02 - Straight answers" />
  </>
);

export const Route = createFileRoute('/_landing/contact')({
  head: () =>
    buildHead({
      title: 'Get a Free Quote | Dreams Built – Hamilton & Waikato',
      description:
        'Request a free fixed quote for concrete foundations, driveways or patios in Hamilton and the Waikato. Call 021 412 384 or send your plans. Quotes back within two working days.',
      path: '/contact',
      jsonLd: [
        breadcrumbJsonLd([
          { name: 'Home', path: '/' },
          { name: 'Contact', path: '/contact' }
        ]),
        faqJsonLd([...HOME_FAQS])
      ]
    }),
  component: ContactPage
});
